import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { 
  OrdersPage, 
  TakeOffToEnRouteSidebar,
  TakeOffToEnRouteMap,
  UpsertOrderMap,
  UpsertOrderSidebar,
  UpsertMissionSidebar,
  UpsertMissionMap,
  ConfirmOrderSidebar,
  ConfirmOrderMap,
  ChecklistMap,
  ChecklistSidebar,
} from './pages';
import { ArcStack } from '@src/core/ui';
import { ArcBaseContent, ArcBaseSidebar } from '@src/core/components';
import { ArcGoogleMap } from '@src/core/controllers';
import { useGoTo } from './hooks';
import ZonesControl from '@src/core/features/zones/components/zones-control';
import CameraMapLayout from './components/camera-view/camera-map-layout';

const OrderFeature: React.FC = () => {
  const { goTo, points, addPosition, position, removePosition, resetGoHere } = useGoTo();
  const location = useLocation();
  const isOrdersPage = location.pathname === '/app/orders' || location.pathname === '/app/orders/';

  return (
    <>
      {isOrdersPage ? (
        <OrdersPage />
      ) : (
        <ArcStack direction='row'>
          <ArcBaseSidebar>
            <Routes>
              <Route path='/create' element={<UpsertOrderSidebar />} />
              <Route path='/update/:orderId' element={<UpsertOrderSidebar />} />
              <Route path='/create-mission/:orderId' element={<UpsertMissionSidebar />} />
              <Route path='/update-mission/:missionId' element={<UpsertMissionSidebar />} />

              <Route path='/checklist/:missionId' element={<ChecklistSidebar />} />
              <Route path='/confirm-order/:missionId' element={<ConfirmOrderSidebar />} />
              <Route path='/take-off-to-en-route/:missionId' element={<TakeOffToEnRouteSidebar />} />
              <Route path='/en-route-viewer/:missionId' element={<TakeOffToEnRouteSidebar viewer />} />
              <Route path='/ready-for-take-off-viewer/:missionId' element={<TakeOffToEnRouteSidebar viewer />} />
            </Routes>
          </ArcBaseSidebar>
          <ArcBaseContent>
            <CameraMapLayout>
              <ArcGoogleMap onRightClick={addPosition}>
                <ZonesControl />

                <Routes>
                  <Route path='/create' element={<UpsertOrderMap />} />
                  <Route path='/update/:orderId' element={<UpsertOrderMap /> } />
                  <Route path='/create-mission/:orderId' element={<UpsertMissionMap />} />
                  <Route path='/update-mission/:missionId' element={<UpsertMissionMap />} />

                  <Route path='/checklist/:missionId' element={<ChecklistMap />} />
                  <Route path='/confirm-order/:missionId' element={<ConfirmOrderMap />} />
                  <Route path='/take-off-to-en-route/:missionId' element={<TakeOffToEnRouteMap points={points} position={position} removePosition={removePosition} goTo={goTo} resetGoHere={resetGoHere} />} />
                  <Route path='/en-route-viewer/:missionId' element={<TakeOffToEnRouteMap viewer resetGoHere={resetGoHere} />} />
                  <Route path='/ready-for-take-off-viewer/:missionId' element={<TakeOffToEnRouteMap viewer resetGoHere={resetGoHere} />} />
                </Routes>
              </ArcGoogleMap>
            </CameraMapLayout>
          </ArcBaseContent>
        </ArcStack>
      )}
    </>
  );
};

export default OrderFeature;